module.exports = __webpack_public_path__ + "static/img/logo-color.b95a5665.png";